//引入依赖及组件
import Vue from 'vue'
import VueRouter from 'vue-router'

// import testSubject from '@/components/someGuide/testSubject.vue'
// import testBambuLab from '@/components/someGuide/testBambuLab.vue'
// import getUrlData from '@/components/someGuide/getUrlData.vue'
// import pageChangeResult from '@/components/pageChangeResult/pageChangeResult.vue'
// import goBackButton from '@/components/goBackButton/goBackButton.vue'
import login from '@/views/account/login.vue'
import localLogin from '@/views/account/localLogin.vue'
import forgotPassword from '@/views/account/forgetPassword.vue'
import changePassword from '@/views/account/changePassword.vue'
import register from '@/views/account/register.vue'
import userCenter from '@/views/account/userCenter.vue'
import deleteUser from '@/views/account/deleteUser.vue'

import deleteAccountPrivacy from '@/views/policies/deleteAccountPrivacy.vue'
import privacy from '@/views/policies/privacy.vue'
import terms from '@/views/policies/terms.vue'
import area from '@/views/area/area.vue'

import {formatLanguage} from '~/utils/utils';

Vue.use(VueRouter);
//设置组件映射规则
const routes = [
    {
        path: '/account/login',
        name: 'login',
        component: login,
        meta: {
            title: '登录',
            titleKey: 'h.login.login',
        }
    },
    {
        path: '/account/localLogin',
        name: 'localLogin',
        component: localLogin,
        meta: {
            title: '本地账号继续登录',
            titleKey: 'h.login.localLogin',
            isAuth: true,
        }
    },
    {
        path: '/account/forgotPassword',
        name: 'forgotPassword',
        component: forgotPassword,
        meta: {
            title: '重置密码',
            titleKey: 'h.forgetPassword.resettingPassword',
        }
    },
    {
        path: '/account/changePassword',
        name: 'changePassword',
        component: changePassword,
        meta: {
            title: '修改密码',
            titleKey: 'h.userCenter.changePassword',
            isAuth:true,
        }
    },
    {
        path: '/account/register',
        name: 'register',
        component: register,
        meta: {
            title: '注册账号',
            titleKey: 'h.register.registerAnAccount',
        }
    },
    {
        path: '/account/userCenter',
        name: 'userCenter',
        component: userCenter,
        meta: {
            title: '个人资料',
            titleKey: 'h.userCenter.personalInformation',
            isAuth:true,
        }
    },
    {
        path: '/account/deleteUser',
        name: 'deleteUser',
        component: deleteUser,
        meta: {
            title: '注销账号',
            titleKey: 'h.userCenter.cancelAccount',
            isAuth:true,
        }
    },
    {
        path: '/policies/deleteAccountPrivacy',
        name: 'deleteAccountPrivacy',
        component: deleteAccountPrivacy,
        meta: {
            title: '删除账号协议',
            titleKey: 'h.policies.deleteAccountPrivacy',
        }
    },
    {
        path: '/policies/privacy',
        name: 'privacy',
        component: privacy,
        meta: {
            title: '隐私政策协议',
            titleKey: 'h.policies.privacyPolicy',
        }
    },
    {
        path: '/policies/terms',
        name: 'terms',
        component: terms,
        meta: {
            title: '用户条款协议',
            titleKey: 'h.policies.agreement',
        }
    },
    {
        path: '/area/area',
        name: 'area',
        component: area,
        meta: {
            title: '地区选择',
            titleKey: 'h.area.regionalSelection',
        }
    }
]


const router = new VueRouter({
    // mode: 'history',
    // mode: 'hash', // history去掉url中的#
    routes
})

/**
 * 路由前置守卫
 */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.meta.isAuth) {
        //判断 如果school本地存储是qinghuadaxue的时候，可以进去
        if (localStorage.getItem('token')) {
            next()  //放行
        } else {
            // //this.$notify.warning({
            //     title:this.$t('h.common.tip'),
            //     message:this.$t('h.common.tipNeedLogin'),
            // })
            // next({path:'/pageChangeResult',query: { iconTpye:'waring',title:'h.common.refuse',subTitle:'h.common.tipNeedLogin',redirect: '/account/login' }})
            next('/account/login')
        }
    } else {
        // 否则，放行
        next()
    }
})


//导出
export default router;



// WEBPACK FOOTER //
// ./src/router/router.js